<template>
    <div class="pos-container">
        <b-modal hide-footer header-bg-variant="" hide-backdrop no-close-on-esc hide-header title="BO Remarks"
            ref="BoRemarks" id="BoRemarks" no-fade no-enforce-focus no-close-on-backdrop
            header-class="addCustomer__header_class" modal-class="addCustomer__modal_class"
            title-class="addCustomer__title_class" size="md" @hide="onHidePopup()">
            <div class="pb-2">
                <div class="col-12 input-material mb-5">
                    <label class="font-weight-bold">Remark</label>
                    <b-form-input type="text" name="remarkText" ref="remarkInputRef" id="remarkText"
                        v-model="remarkData" autofocus @focus="() => {
                Object.keys(keyboardsVisible).map((x) => {
                    if (x == 'remarkText') {
                        keyboardsVisible[x] = true;
                    } else {
                        keyboardsVisible[x] = false;
                    }
                });
            }
                " />
                    <VkeyboardFloat :ID="'remarkText'" :onClickFun="() => {
                Object.keys(keyboardsVisible).map((x) => {
                    if (x == 'remarkText') {
                        keyboardsVisible[x] = !keyboardsVisible[x];
                    } else {
                        keyboardsVisible[x] = false;
                    }
                });
            }
                " />
                    <Vkeyboard :inputName="'remarkText'" :showOrHide="keyboardsVisible.remarkText"
                        :initialValue="remarkData" @changeKeyboardInput="remarkData = $event" @onKeyEnter="() => {
                this.passData();
            }
                " @onClickClose="() => {
                keyboardsVisible.remarkText = false;
            }
                " />
                </div>
                <div class="col-12 d-flex">
                    <div class="input-material text-center mr-1">
                        <button class="btn btn-blue" @click="cancelRemarks()">Cancel</button>
                    </div>
                    <div class="input-material text-center">
                        <button class="btn btn-blue" @click="passData()">Submit</button>
                    </div>
                </div>
            </div>

            <!-- <template #modal-footer>
               
            </template> -->
        </b-modal>
    </div>
</template>

<script>
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

export default {
    components: {
        Vkeyboard,
        VkeyboardFloat,
    },
    mounted() {
        // this.$refs.input
    },
    data() {
        return {
            remarkData: "",
            keyboardsVisible: {
                remarkText: true,
            },
        };
    },
    methods: {
        onHidePopup() {
            this.$bvModal.hide("BO Remarks");
        },
        passData() {
            this.$store.dispatch("updateBoRemarks", this.remarkData);
            this.$bvModal.hide("BoRemarks");
        },
        cancelRemarks() {
            this.$store.dispatch("updateBoRemarks", "");
            this.$bvModal.hide("BoRemarks");
        }
    },
};
</script>

<style>
.pos-cash-calculator {
    margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/BoRemarks.vue